import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as usersActionCreators from "../redux/modules/users";
import { Login } from "../components";
import cookie from "react-cookies";
import authUser from "../helpers/users/authUser";
import logLogin from "../helpers/users/logLogin";
import getHomePath from "../helpers/users/getHomePath";
import getAllDistrictsInState from "../helpers/users/getAllDistrictsInState";
import sortByPropText from "../helpers/content/manageSets/sortByPropText";
import getOneByProp from "../helpers/users/getOneByProp";
import pingAuthEducator from "../helpers/users/pingAuthEducator";
import setUserTurorialFlag from "../helpers/users/setUserTurorialFlag";

class SignInContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      err: false,
      reset: false,
      emailStatus: false,
      passwordStatus: false,
      lock: false,
      emailatuserstatus : false,
      iswait : false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    // pings authEducator cloud function to reduce spin-up time
    // to check password
    pingAuthEducator();
  }

  emailAtUsername = () =>{
    this.setState({iswait:true,err:false,emailatusernamestatus:false})
    setTimeout(()=>{
      this.setState({iswait:false,emailatusernamestatus:true})
    },1000 )

  }

  handleChange(e) {
    const { emailStatus, passwordStatus } = this.state;
    const { target } = e;
    const { value, name } = target;

    // turns off warning if missing pw or email and start
    // entering it
    if (name === "email" && emailStatus) {
      this.setState({ emailStatus: false });
    }
    if (name === "password" && passwordStatus) {
      this.setState({ passwordStatus: false });
    }

    this.setState({
      [name]: value
    });
  }

  handleSubmit(e, selectedDistrictId) {
    this.setState({emailatusernamestatus:false})
    // submits email/username and password for auth
    e.preventDefault();
    const { email, password , lock, emailatuserstatus } = this.state
    const { authingUserSuccess } = this.props;
    const onlock = this.state.lock;
    this.setState({ lock: !onlock });
    if (email === "") {
      this.setState({ emailStatus: true });
      setTimeout(() => {
        this.setState({ emailStatus: false });
      }, 2000);
    }
    if (password === "") {
      this.setState({ passwordStatus: true });
      setTimeout(() => {
        this.setState({ passwordStatus: false });
      }, 2000);
    }
    this.setState({ err: false, reset: false });
    if (this.state.email && this.state.password) {
      this.props.authingUser();
      // Always include email, password, and success state in args
      // Also include districtId if we have it
      const args = [email, password, authingUserSuccess];
      if (selectedDistrictId) args.push(selectedDistrictId);
      authUser
        .apply(this, args)
        .then(res => {
          logLogin(res.user.id, res.user.role);
          let user_id = res.user.id;
          //setUserTurorialFlag(user_id, false, false);
          if (
            this.props.location.pathname.toLowerCase().indexOf("login") > -1
          ) {
            // Finds the redirect path and sends user to it
            const homePath = getHomePath(res.user);
            this.props.history.push("");
            this.props.history.push(homePath);
          }
          if (
            this.props.location.pathname
              .toLowerCase()
              .indexOf("signin-username") > -1
          ) {
            // Finds the redirect path and sends user to it
            const homePath = getHomePath(res.user);
            this.props.history.push("");
            this.props.history.push(homePath);
          }
          if (
            this.props.location.pathname
              .toLowerCase()
              .indexOf("signin-username") > -1
          ) {
            // Finds the redirect path and sends user to it
            const homePath = getHomePath(res.user);
            this.props.history.push("");
            this.props.history.push(homePath);
             
          }
          localStorage.setItem("is_loader",0);
        })
        .catch(err => {
          this.setState({ err: true });
          this.props.authingUserError(err);
        })
        .catch(err => {
          this.setState({ err: true });
          setTimeout(() => {
            this.setState({ reset: true });
          }, 2000);
          // setTimeout(()=>{
          //   this.setState({ err : false , reset:true })
          // },5000)
          this.props.authingUserError(err);
        });
    }
  }

  render() {
    let { lock } = this.state;

    return (
      <Login
        iswait = {this.state.iswait}
        emailAtUsername = {this.emailAtUsername}
        emailatusernamestatus = {this.state.emailatusernamestatus}
        lock={this.state.lock}
        passwordStatus={this.state.passwordStatus}
        emailStatus={this.state.emailStatus}
        email={this.state.email}
        reset={this.state.reset}
        err={this.state.err}
        emailVal={this.state.email}
        handleChange={this.handleChange}
        passwordVal={this.state.password}
        handleSubmit={this.handleSubmit}
        notFound={this.props.notFound}
        isFetching={this.props.isFetching}
        isAuthingEducator={this.props.isAuthingEducator}
        isAuthingEducatorError={this.props.isAuthingEducatorError}
        isAuthing={this.props.isAuthing}
        isAuthingError={this.props.isAuthingError}
        history={this.props.history}
        location={this.props.location}
      />
    );
  }
}

export default connect(
  state => ({
    isFetching: state.users.isFetching,
    error: state.users.error,
    notFound: state.users.notFound,
    isAuthed: state.users.isAuthed,
    role: state.users.role,
    isAuthingEducator: state.users.isAuthingEducator,
    isAuthingEducatorError: state.users.isAuthingEducatorError,
    educator: state.users.educator,
    isAuthing: state.users.isAuthing,
    isAuthingError: state.users.isAuthingError,
    districts: state.districts
  }),
  dispatch => bindActionCreators(usersActionCreators, dispatch)
)(SignInContainer);



// WEBPACK FOOTER //
// ./src/containers/SignInContainer.js